import { createFileRoute, Outlet } from "@tanstack/react-router";

// Layout route: the page itself lives in fr.index.tsx. Without this wrapper the
// page component would shadow every nested child route.
export const Route = createFileRoute("/fr")({
  component: RouteLayout,
});

function RouteLayout() {
  return <Outlet />;
}
